import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicProjectDeleteParamsRawI,
	LWApiPublicProjectDeleteResultRawI,
} from '@liquidweb-dev/club-sauce/public/project/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { PROJECT_LIST_QUERY_KEY } from './useList';

const useProjectDelete = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicProjectDeleteResultRawI,
		ApiErrorI,
		LWApiPublicProjectDeleteParamsRawI
	>({
		mutationFn: (params) => api.project.apiRaw.delete(params),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [PROJECT_LIST_QUERY_KEY],
			});
		},
		onError: snackbarError,
	});
};

export default useProjectDelete;
